export const VERIFY_PRICE_SORT_OPTIONS = [
  { value: "-record_at,-date_created", label: "Newest first" },
  { value: "record_at,date_created", label: "Oldest first" },
  { value: "product_name", label: "Product (A–Z)" },
  { value: "-product_name", label: "Product (Z–A)" },
  { value: "retailer", label: "Retailer (A–Z)" },
  { value: "-retailer", label: "Retailer (Z–A)" },
  { value: "-unit_price", label: "Unit price (high to low)" },
  { value: "unit_price", label: "Unit price (low to high)" },
];

export const VERIFY_PRICE_VERIFIED_VIEW_OPTIONS = [
  { value: "unverified", label: "Not verified" },
  { value: "verified", label: "Verified" },
  { value: "both", label: "Both" },
  { value: "voided", label: "Voided" },
];

export const DEFAULT_VERIFY_PRICE_PAGE_SIZE = 24;
export const VERIFY_PRICE_PAGE_SIZE_OPTIONS = [8, 16, 24];

export function completionPercent(verifiedCount, totalCount) {
  if (!totalCount) return 0;
  return Math.round((verifiedCount / totalCount) * 100);
}

/**
 * @param {{ id?: string }[]} rows
 * @param {string | null} currentId
 * @param {1 | -1} direction
 */
export function getNeighborRecordId(rows, currentId, direction) {
  const index = (rows || []).findIndex((row) => row.id === currentId);
  if (index < 0) return null;
  return rows[index + direction]?.id ?? null;
}

/**
 * @param {{
 *   rows: { id?: string }[],
 *   currentId: string | null,
 *   direction: 1 | -1,
 *   page: number,
 *   totalCount: number,
 *   pageSize: number,
 * }} params
 */
export function planVerifyPriceAdvance({
  rows,
  currentId,
  direction,
  page,
  totalCount,
  pageSize,
}) {
  const neighborId = getNeighborRecordId(rows, currentId, direction);
  if (neighborId) {
    return { type: "select", id: neighborId };
  }

  const maxPage = Math.max(0, Math.ceil((totalCount || 0) / pageSize) - 1);
  if (direction > 0 && page < maxPage) {
    return { type: "page", page: page + 1, select: "first" };
  }
  if (direction < 0 && page > 0) {
    return { type: "page", page: page - 1, select: "last" };
  }
  return { type: "none" };
}

function compareDates(left, right) {
  const leftMs = left?.valueOf?.() ?? 0;
  const rightMs = right?.valueOf?.() ?? 0;
  return leftMs - rightMs;
}

function compareVerifyPriceItems(left, right, sortKey) {
  switch (sortKey) {
    case "record_at,date_created":
      return compareDates(left.recordAtValue, right.recordAtValue);
    case "product_name":
      return String(left.product || "").localeCompare(String(right.product || ""), undefined, {
        sensitivity: "base",
      });
    case "-product_name":
      return String(right.product || "").localeCompare(String(left.product || ""), undefined, {
        sensitivity: "base",
      });
    case "retailer":
      return String(left.retailer || "").localeCompare(String(right.retailer || ""), undefined, {
        sensitivity: "base",
      });
    case "-retailer":
      return String(right.retailer || "").localeCompare(String(left.retailer || ""), undefined, {
        sensitivity: "base",
      });
    case "unit_price":
      return (left.unitPriceValue ?? 0) - (right.unitPriceValue ?? 0);
    case "-unit_price":
      return (right.unitPriceValue ?? 0) - (left.unitPriceValue ?? 0);
    case "-record_at,-date_created":
    default:
      return compareDates(right.recordAtValue, left.recordAtValue);
  }
}

export function sortVerifyPriceItems(items, sort) {
  const list = [...(items || [])];
  list.sort((left, right) => compareVerifyPriceItems(left, right, sort));
  return list;
}

export function isEditableKeyboardTarget(target) {
  if (!target || typeof target !== "object") return false;
  const element = target;
  const tagName = String(element.tagName || "").toLowerCase();
  if (tagName === "input" || tagName === "textarea" || tagName === "select") {
    return true;
  }
  return Boolean(element.isContentEditable);
}
